// extracted by mini-css-extract-plugin
module.exports = {"cell":"V4Disc_cell__2f6KC"};